import { render, staticRenderFns } from "./StreamDisplayItemRundown.vue?vue&type=template&id=63875dfc&"
import script from "./StreamDisplayItemRundown.vue?vue&type=script&lang=js&"
export * from "./StreamDisplayItemRundown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports